import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const RankingService = {
  async getRankingMatches(playerId, rankingId) {
    return safeRequest(
      apiClient
        .get(`/rankings/${rankingId}/players/${playerId}/matches`)
        .then((response) => response.data),
    );
  },
  async getStandings(rankingId) {
    return safeRequest(
      apiClient
        .get(`/rankings/${rankingId}/standings`)
        .then((response) => response.data),
    );
  },
  async updateMyAvailability(rankingId, isAvailable) {
    return safeRequest(
      apiClient
        .patch(`/rankings/${rankingId}/my-availability`, { isAvailable })
        .then((response) => response.data),
    );
  },
};
